import React from 'react'
import useModelValue from './use-model-value'
import useName from './use-name'

export default function useValue (name = '', defaultValue = null) {
  const modelName = useName(name)
  const modelValue = useModelValue(modelName, defaultValue)

  return modelValue
}
